import React from 'react';
import { useHistory } from 'react-router-dom';
import { managerRoutes } from '../../../../../manager/routes';
import { Button } from 'react-bootstrap';
import { useNamespacedTranslation } from '../../../../../../../hooks/useNamespacedTranslation';

type Props = {
  employeeId: string;
  documentId: string;
};

export const EmployeeDocumentDetails: React.FC<
  React.PropsWithChildren<Props>
> = ({ employeeId, documentId }) => {
  const history = useHistory();
  const t = useNamespacedTranslation('approvalRequest.detailsSidebar');

  const handleViewDetails = () => {
    const path =
      managerRoutes.documents.route.create({ employeeId }) +
      `?documentId=${documentId}`;
    history.push(path);
  };

  return (
    <div className="d-flex">
      <Button
        variant="link"
        className="p-0 text-decoration-none"
        onClick={handleViewDetails}>
        {t('viewDetails')}
      </Button>
    </div>
  );
};
